import PropTypes from 'prop-types';
import React, { Component } from 'react';

const propTypes = {
  children: PropTypes.any,
  provider: PropTypes.object,
};
export default class PlayerProvider extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    console.log('PlayerProvider');
  }

  componentWillUnmount() {
  }

  render() {
    const { children, provider, store } = this.props;
    return (
      <div>
        {children}
        <div className="player-provider">

        </div>
      </div>
    );
  }
}

PlayerProvider.contextTypes = { store: PropTypes.object };
PlayerProvider.propTypes = propTypes;
PlayerProvider.displayName = 'PlayerProvider';
